import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getFindUserContextPreferencesKey = (): UseDataQuery['queryKey'] => [
  DataQueryKey.USER_CONTEXT_PREFERENCES,
  undefined,
];
